<template>
  <IngredientsOrder
    disable-team-filter
    do-not-load-team-assignments
    paging
    exclude-allergy
    show-export-button
    :data-as-table-function="dataAsTable"
    :category-data-as-table-function="categoryDataAsTable"
    date-range-picker
  />
</template>


<script>
import IngredientsOrder from '@/components/IngredientsOrder';
import {formatWeightWithUnits} from "@/store/utils";

// ingredient names are tagged with the food id, as in 'carrot, whole [12345]'
const FOOD_ID = /\s*\[[^\]]*]\s*$/;


export default {
  components: {IngredientsOrder},
  methods: {
    dataAsTable(ingredients, header, search) {
      console.log('dataAsTable', {ingredients, header, search});
      return ingredients.map(i => ({
          'buy amount needed': formatWeightWithUnits(i.buyAmountValue),
          'raw amount needed': formatWeightWithUnits(i.rawAmountValue),
          name: i.name.split(':::')[0],
          description: i.name.split(':::')[1] || '',
          category: i.category,
          note: i.note || ''
        })
      );
    },
    categoryDataAsTable(ingredients, header, search, format, category) {
      return format === 'pdf'
        ? this.checklistRows(ingredients, category)
        : this.shoppingListRows(ingredients);
    },
    // the shopping list handed to a buyer - the two blank columns are filled in by hand.
    // the units are put on a second line to keep those columns narrow
    shoppingListRows(ingredients) {
      return ingredients.map(i => ({
          'NAME': i.name.split(':::')[0],
          'NEEDED': formatWeightWithUnits(i.buyAmountValue),
          'LAST WEEK\n(KG or LB)': '',
          'ON HAND\n(KG or LB)': '',
          'DESCRIPTION': i.name.split(':::')[1] || '',
          'CATEGORY': i.category,
          'NOTE': i.note || ''
        })
      );
    },
    // the printed checklist is two narrow columns to a page, so it carries the name and nothing but
    // what identifies it - its food id and whichever other categories it is in, small underneath
    checklistRows(ingredients, category) {
      return ingredients.map(i => ({
          'NAME': {
            text: i.name.split(':::')[0].replace(FOOD_ID, ''),
            footnote: [this.foodId(i), this.otherCategories(i, category)].filter(Boolean).join(' ')
          },
          'NEEDED': formatWeightWithUnits(i.buyAmountValue),
          'LAST WEEK\n(KG or LB)': '',
          'ON HAND\n(KG or LB)': ''
        })
      );
    },
    // the [123] the name is tagged with, kept in its brackets to read as the same thing it does there
    foodId(ingredient) {
      const tagged = ingredient.name.split(':::')[0].match(FOOD_ID);
      return tagged ? tagged[0].trim() : '';
    },
    otherCategories(ingredient, category) {
      return (ingredient.categories || []).filter(c => c && c !== category).join(', ');
    }
  }
}
</script>
